import React, {Component} from "react";
import {Button, Col, Form, Row} from "react-bootstrap";
import Modal from "react-responsive-modal";
import DashboardService from "../services/DashboardService";
import "./UpgradeModal.css";
import BuildService from "../services/BuildService";

export default class UpgradeModal extends Component {
    FIRMWARE_TYPE = {
        SWITCH_STM_IMAGE: "SWITCH_STM_IMAGE",
        SWITCH_DEVICE_IMAGE: "SWITCH_DEVICE_IMAGE",
        WIFI_IMAGE : "WIFI_IMAGE"
    };

    state = {
        data: [],
        email: "",
        isValidated: false,
        builds: [],
        isForcedUpgradeSwitch: false,
        isForcedUpgradeAc: false,
        buildDialogErrors: [],
        buildOptions: [],
        selectedSwitchBuild: "",
        selectedSwitchFirmwareType: "",
        selectedAcBuild: "",
        selectedAcFirmwareType: ""
        };

    constructor(props) {
        super(props);
        this.validateForms = this.validateForms.bind(this);
        this.validateSwitchForm = this.validateSwitchForm.bind(this);
        this.validateAcForm = this.validateAcForm.bind(this);
        this.toggleChangeForcedUpgradeSwitch = this.toggleChangeForcedUpgradeSwitch.bind(this);
        this.onSelectSwitchBuild = this.onSelectSwitchBuild.bind(this);
        this.onSelectSwitchFirmwareType = this.onSelectSwitchFirmwareType.bind(this);
        this.toggleChangeForcedUpgradeAc = this.toggleChangeForcedUpgradeAc.bind(this);
        this.onSelectAcBuild = this.onSelectAcBuild.bind(this);
        this.onSelectAcFirmwareType = this.onSelectAcFirmwareType.bind(this);
        this.getBuildList = this.getBuildList.bind(this);
    }

    componentDidMount() {
        if (this.props.buildOptions && this.props.buildOptions.length > 0) {
            this.setState({selectedSwitchBuild: this.props.buildOptions[0].id});
        }

        if (this.props.buildAcOptions && this.props.buildAcOptions.length > 0) {
            this.setState({selectedAcBuild: this.props.buildAcOptions[0].id});
        }
        this.getBuildList();
    }

    componentDidUpdate (prevProps) {
        if(this.props.selectedDevices.length !== prevProps.selectedDevices.length || this.props.selectedAc.length !== prevProps.selectedAc.length ) {
            this.setState({
                buildDialogErrors: [null,null,null]
            })
        }
    }

    validateForms() {
        let errors = [null, null, null];

        if (this.props.selectedDevices.length === 0 && this.props.selectedAc.length === 0 ) {
            errors[0] = "Please select devices using checkbox";
        }

        for (let i = 0; i < errors.length; i++) {
            if (errors[i] !== null) {
                this.setState({buildDialogErrors: errors});
                return
            }
        }

        this.validateSwitchForm();
        this.validateAcForm();
        this.props.onCloseClicked();
    }

    validateSwitchForm() {
        if (this.state.selectedSwitchFirmwareType === "" || this.state.selectedSwitchBuild === "") {
            return
        }

        const request = {
            buildId: this.state.selectedSwitchBuild,
            buildType: this.state.selectedSwitchFirmwareType,
            deviceMacs: this.props.selectedDevices,
            forceUpgrade: this.state.isForcedUpgradeSwitch
        };
        return this.upgradeDevice(request);
    }

    validateAcForm () {

        if (this.state.selectedAcFirmwareType === "" || this.state.selectedAcBuild === "") {
            return
        }
        
        const request = {
            buildId: this.state.selectedAcBuild,
            buildType: this.state.selectedAcFirmwareType,
            deviceMacs: this.props.selectedAc,
            forceUpgrade: this.state.isForcedUpgradeAc
        };

        return this.upgradeDevice(request);
    }

    upgradeDevice(request) {
        try {
            DashboardService.upgradeDevice(request);   
            return true;   
        } catch (e) {
            alert(e.message);
            console.log(e.message)
        } finally {
            this.setState({buildNumber: "", buildUrl: "", isForcedUpgradeSwitch: false})
        }
    };
    
    toggleChangeForcedUpgradeSwitch = () => {
        this.setState(prevState => ({
            isForcedUpgradeSwitch: !prevState.isForcedUpgradeSwitch,
        }));
    };

    toggleChangeForcedUpgradeAc = () => {
        this.setState(prevState => ({
            isForcedUpgradeAc: !prevState.isForcedUpgradeAc,
        }));
    };

    onSelectSwitchBuild = function (event) {
        this.setState({selectedSwitchBuild: event.target.value});
    };

    onSelectSwitchFirmwareType = function (event) {
        this.setState({selectedSwitchFirmwareType: event.target.value});
    };

    onSelectAcBuild = function (event) {
        this.setState({selectedAcBuild: event.target.value});
    };

    onSelectAcFirmwareType = function (event) {
        this.setState({selectedAcFirmwareType: event.target.value});
    };
    
    async getBuildList() {
        const buildList = await BuildService.getBuilds();
        this.setState({  builds : buildList  })
    }
  
    render() {
        return (
            <Modal open={this.props.show} onClose={this.props.onCloseClicked}>
                <h4 style={{width: "700px"}}>Upgrade {this.props.selectedDevices.length} Switch(es)</h4>
                <hr/>
                <Row>
                    <Form>
                        <Form.Group controlId="upgradeForm.ControlInput1">
                            <Col sm={1}>
                                <div style={{marginTop: 4}}>
                                    Type:
                                </div>
                            </Col>
                            <Col sm={4}>
                                <select className="form-control" value={this.state.selectedSwitchFirmwareType}
                                        onChange={this.onSelectSwitchFirmwareType}>
                                    <option value="">Select Type</option>
                                    <option value="SWITCH_DEVICE_IMAGE">Switch Firmware</option>
                                    <option value="SWITCH_STM_IMAGE">Switch STM</option>
                                    <option value="WIFI_IMAGE">WiFi Firmaware</option>
                                </select>
                            </Col>
                        </Form.Group>
                    </Form>
                </Row>
                <Row>
                    <Form>
                        <Form.Group controlId="upgradeForm.ControlInput1">
                            <Col sm={1}>
                                <div style={{marginTop: 4}}>
                                    Build:
                                </div>
                            </Col>
                    
                            <Col sm={4}>
                                <select className="form-control" value={this.state.selectedSwitchBuild}
                                onChange={this.onSelectSwitchBuild}>
                                <option value="">Select Build</option>
                                {
                                this.state.builds.filter(e => e.firmwareType === this.state.selectedSwitchFirmwareType).map((e, key) => {
                                const buildVersion = e.major + "." + e.minor + "." + e.revision;
                                return <option className ={`${e.goldenBuild ? "goldenBuild" : ""}`} key={key} value={e.id}> {buildVersion} </option>;
                                })
                                }
                                </select>
                            </Col>
                            <Col sm={4}>
                                <div className="form-check" style={{marginTop: 4}}>
                                    <label className="form-check-label">
                                        <input type="checkbox"
                                               style={{marginRight: 6}}
                                               checked={this.state.isForcedUpgradeSwitch}
                                               onChange={this.toggleChangeForcedUpgradeSwitch}
                                               className="form-check-input"
                                        />
                                        Force
                                    </label>
                                </div>
                            </Col>
                        </Form.Group>
                    </Form>
                </Row>
                <br/>
                <h4 style={{width: "700px"}}>Upgrade {this.props.selectedAc.length} AC(s)</h4>
                <hr/>
                <Row>
                    <Form>
                        <Form.Group controlId="upgradeForm.ControlInput1">
                            <Col sm={1}>
                                <div style={{marginTop: 4}}>
                                    Type:
                                </div>
                            </Col>
                            <Col sm={4}>
                                <select className="form-control" value={this.state.selectedAcFirmwareType}
                                        onChange={this.onSelectAcFirmwareType}>
                                    <option value="">Select Type</option>
                                    <option value="AC_DEVICE_IMAGE">AC Firmware</option>
                                    <option value="WIFI_IMAGE">WiFi Firmaware</option>
                                    <option value="PCB_IMAGE">PCB Firmaware</option>
                                </select>
                            </Col>
                        </Form.Group>
                    </Form>
                </Row>
                <Row>
                    <Form>
                        <Form.Group controlId="upgradeForm.ControlInput1">
                            <Col sm={1}>
                                <div style={{marginTop: 4}}>
                                    Build:
                                </div>
                            </Col>
                            <Col sm={4}>
                                <select className="form-control" value={this.state.selectedAcBuild}
                                        onChange={this.onSelectAcBuild}>
                                    <option value="">Select Build</option>
                                    {
                                        this.props.buildAcOptions.filter(e => e.firmwareType === this.state.selectedAcFirmwareType).map((e, key) => {
                                            return <option key={key} value={e.id}>{e.version}</option>;
                                        })
                                    }
                                </select>
                            </Col>
                            <Col sm={4}>
                                <div className="form-check" style={{marginTop: 4}}>
                                    <label className="form-check-label">
                                        <input type="checkbox"
                                               style={{marginRight: 6}}
                                               checked={this.state.isForcedUpgradeAc}
                                               onChange={this.toggleChangeForcedUpgradeAc}
                                               className="form-check-input"
                                        />
                                        Force
                                    </label>
                                </div>
                            </Col>
                        </Form.Group>
                    </Form>
                </Row>
                <br/>
                <Row>
                    <Col sm={12}>
                        <div style={{color: "red"}}>
                            {(this.state.buildDialogErrors[0] === null) ? "" : this.state.buildDialogErrors[0]}
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col sm={12}>
                    <Button variant="primary" style={{margin: 20}}
                                onClick={this.validateForms}>Submit</Button>
                    </Col>
                </Row>
            </Modal>
        )
    }
}